"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetStartedCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className="relative bg-background py-20 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className={`mb-8 text-4xl font-semibold text-foreground transition-all duration-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Ready to Transform Your Business?
        </h2>

        <Link to="/ContactPage">
          <Button size="lg" className={`btn-primary scale-100 shadow-soft transition-all duration-150 ease-in-out hover:scale-102 hover:shadow-medium active:scale-100 active:shadow-soft ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
          transitionDelay: isVisible ? "150ms" : "0ms"
        }}>
            Schedule a Consultation
          </Button>
        </Link>
      </div>
    </section>;
}